var exports = {
  "k": "xfd349460--d0da80--container",
};

module.exports = exports;
